import { render, staticRenderFns } from "./SelectCorporationView.vue?vue&type=template&id=264fe4b9&"
import script from "./SelectCorporationView.vue?vue&type=script&lang=js&"
export * from "./SelectCorporationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports